module.exports = __webpack_public_path__ + "img/toad-pad.648b8818.svg";